<template>
    <div class="app-container">
        <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="80px">
            <el-form-item label="房号" prop="fangNo">
                <el-input
                    v-model="queryParams.fangNo"
                    placeholder="请输入房号"
                    clearable
                    @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="姓名" prop="userName">
                <el-input
                    v-model="queryParams.userName"
                    placeholder="请输入姓名"
                    clearable
                    @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="类型" prop="type">
                <el-select v-model="queryParams.type" placeholder="请选择">
                    <el-option
                        v-for="item in type"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <!--      <el-form-item label="金额" prop="money">-->
            <!--        <el-input-->
            <!--          v-model="queryParams.money"-->
            <!--          placeholder="请输入金额"-->
            <!--          clearable-->
            <!--          @keyup.enter.native="handleQuery"-->
            <!--        />-->
            <!--      </el-form-item>-->
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table v-loading="loading" :data="shuidianInfoList" @selection-change="handleSelectionChange">
            <!--      <el-table-column type="selection" width="55" align="center"/>-->
            <!--      <el-table-column label="${comment}" align="center" prop="id" />-->
            <el-table-column label="房号" align="center" prop="fangNo"/>
            <el-table-column label="姓名" align="center" prop="userName"/>
            <el-table-column label="类型" align="center" prop="type">
                <template slot-scope="scope">
                    <label style="color: #67C23A" v-if="scope.row.type=='水费'">水费</label>
                    <label style="color: #F56C6C" v-if="scope.row.type=='电费'">电费</label>
                </template>
            </el-table-column>
            <el-table-column label="旧值" align="center" prop="oldValue"/>
            <el-table-column label="新值" align="center" prop="newValue"/>
            <el-table-column label="规则" align="center" prop="guiZe"/>
            <el-table-column label="使用量" align="center" prop="mingXi"/>
            <el-table-column label="金额" align="center" prop="money">
                <template slot-scope="scope">
                    <label>- {{ (scope.row.money / 100).toFixed(3) }}元</label>

                </template>
            </el-table-column>
            <el-table-column label="交易时间" align="center" prop="createTime"/>
        </el-table>

        <pagination
            v-show="total>0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />

        <!-- 添加或修改水电费扣减记录对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="房号" prop="fangNo">
                    <el-input v-model="form.fangNo" placeholder="请输入房号"/>
                </el-form-item>
                <el-form-item label="姓名" prop="userName">
                    <el-input v-model="form.userName" placeholder="请输入姓名"/>
                </el-form-item>
                <el-form-item label="金额" prop="money">
                    <el-input v-model="form.money" placeholder="请输入金额"/>
                </el-form-item>
                <el-form-item label="删除标志" prop="delFlag">
                    <el-input v-model="form.delFlag" placeholder="请输入删除标志"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    listShuidianInfo,
    getShuidianInfo,
    delShuidianInfo,
    addShuidianInfo,
    updateShuidianInfo
} from "@/api/homestay/api";

export default {
    name: "ShuidianInfo",
    data() {
        return {
            // 根路径
            baseURL: process.env.VUE_APP_BASE_API,
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 水电费扣减记录表格数据
            shuidianInfoList: [],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            type: [{
                value: '水费',
                label: '水费'
            }, {
                value: '电费',
                label: '电费'
            }],
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                fangNo: null,
                type: null,
                userName: null,
                money: null,
            },
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                id: [
                    {required: true, message: "$comment不能为空", trigger: "blur"}
                ],
                fangNo: [
                    {required: true, message: "房号不能为空", trigger: "blur"}
                ],
                type: [
                    {required: true, message: "类型 水费 电费不能为空", trigger: "change"}
                ],
                userName: [
                    {required: true, message: "姓名不能为空", trigger: "blur"}
                ],
                money: [
                    {required: true, message: "金额不能为空", trigger: "blur"}
                ],
                delFlag: [
                    {required: true, message: "删除标志不能为空", trigger: "blur"}
                ],
            }
        };
    },
    created() {
        this.getList();
    },
    methods: {
        /** 查询水电费扣减记录列表 */
        getList() {
            this.loading = true;
            listShuidianInfo(this.queryParams).then(response => {
                this.shuidianInfoList = response.data;
                this.total = response.total;
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                id: null,
                fangNo: null,
                type: null,
                userName: null,
                money: null,
                delFlag: null,
            };
            this.resetForm("form");
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id)
            this.single = selection.length !== 1
            this.multiple = !selection.length
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加水电费扣减记录";
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            const id = row.id || this.ids.join(',')
            getShuidianInfo(id).then(response => {
                this.form = response.data;
                this.open = true;
                this.title = "修改水电费扣减记录";
            });
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.form.id != null) {
                        updateShuidianInfo(this.form).then(() => {
                            this.$modal.msgSuccess("修改成功");
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        addShuidianInfo(this.form).then(() => {
                            this.$modal.msgSuccess("新增成功");
                            this.open = false;
                            this.getList();
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const ids = row.id || this.ids.join(',');
            this.$modal.confirm('是否确认删除水电费扣减记录编号为"' + ids + '"的数据项？').then(function () {
                return delShuidianInfo(ids);
            }).then(() => {
                this.getList();
                this.$modal.msgSuccess("删除成功");
            }).catch(() => {
            });
        },
        /** 导出按钮操作 */
        handleExport() {
            this.download('fang/shuidianInfo/export', {
                ...this.queryParams
            }, `shuidianInfo_${new Date().getTime()}.xlsx`)
        }
    }
};
</script>
